import { createFileRoute } from '@tanstack/react-router'
import { requireAuthBeforeLoad } from '@/features/auth/guards'
import { AppShell } from '@/features/app-shell/app-shell'
import { SettingsCanvas } from '@/features/app-shell/canvases/settings-canvas'

export const Route = createFileRoute('/app/settings')({
  beforeLoad: ({ location }) => requireAuthBeforeLoad({ location }),
  validateSearch: (search: Record<string, unknown>) => ({
    section: search.section === 'socials' ? 'socials' as const : undefined,
  }),
  component: AppSettingsPage,
})

function AppSettingsPage() {
  const { section } = Route.useSearch()
  return (
    <AppShell activePath="/app/settings">
      <SettingsCanvas initialSection={section} />
    </AppShell>
  )
}
